// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-page {
    padding: 20px;
}

.users-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.users-header h1 {
    font-size: 1.6rem;
}

.add-user-btn {
    background: #4caf50;
    color: white;
    padding: 8px 14px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    font-weight: 600;
}

.add-user-btn:hover {
    background: #449d48;
}

/* Table */
.users-table-wrapper {
    background: var(--card-bg);
    padding: 20px;
    border-radius: 12px;
    border: 1px solid #cfd6dd;
}

.dark .users-table-wrapper {
    border-color: #2a333a;
}

.users-table {
    width: 100%;
    border-collapse: collapse;
}

.users-table th {
    text-align: left;
    padding-bottom: 12px;
    font-size: 0.9rem;
    opacity: 0.7;
}

.users-table td {
    padding: 12px 0;
    border-bottom: 1px solid rgba(0,0,0,0.06);
}

.dark .users-table td {
    border-bottom-color: rgba(255,255,255,0.06);
}

/* Badges rôle */
.role-badge {
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 0.8rem;
    font-weight: 600;
}

.role-badge.admin {
    background: rgba(211, 47, 47, 0.15);
    color: #d32f2f;
}

.role-badge.moderateur {
    background: rgba(249, 168, 37, 0.15);
    color: #f9a825;
}

.role-badge.utilisateur {
    background: rgba(25, 118, 210, 0.15);
    color: #1976d2;
}

/* Badges statut */
.status-badge {
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 0.8rem;
    font-weight: 600;
}

.status-badge.actif {
    background: rgba(76, 175, 80, 0.15);
    color: #4caf50;
}

.status-badge.suspendu {
    background: rgba(211, 47, 47, 0.15);
    color: #d32f2f;
}

/* Actions */
.actions button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.1rem;
    margin-right: 8px;
}

.actions button:hover {
    opacity: 0.7;
}

.seeyou {
    display: flex;
    align-items: center;
}

.seeyou button:hover {
    opacity: 0.7;
}

.seeyou button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.1rem;
    /*margin-right: 8px;*/
}

/* Message button */
.message-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    margin-right: 8px;
    padding: 6px 8px;
    border-radius: 6px;
    transition: background 120ms ease, transform 120ms ease;
}

.message-btn:hover {
    background: rgba(0,0,0,0.04);
    transform: translateY(-2px);
}

.dark .message-btn:hover {
    background: rgba(255,255,255,0.03);
}

/* Drawer action buttons: make Send/Cancel same size inside drawers */
.drawer .drawer-actions {
    display: flex;
    gap: 10px;
    margin-top: 8px;
}



.drawer .drawer-actions .save-user-btn {
    font-weight: 700;
}

/* Overlay */
.drawer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.35);
    backdrop-filter: blur(2px);
    display: flex;
    justify-content: flex-end;
    z-index: 200;
}

/* Drawer */
.drawer {
    width: 340px;
    background: var(--card-bg);
    height: 100%;
    padding: 24px;
    border-left: 1px solid #cfd6dd;
    animation: drawerSlide 0.25s ease-out;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.dark .drawer {
    border-color: #2a333a;
}

@keyframes drawerSlide {
    from {
        transform: translateX(100%);
    }
    to {
        transform: translateX(0);
    }
}

/* Inputs */
.drawer input,
.drawer select {
    padding: 8px;
    border-radius: 6px;
    border: 1px solid #cfd6dd;
    background: var(--bg);
    color: var(--text);
}

.dark .drawer input,
.dark .drawer select {
    border-color: #2a333a;
}

/* Save button */
.save-user-btn {
    margin-top: 10px;
    background: #4caf50;
    color: white;
    padding: 10px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    font-weight: 600;
}

.save-user-btn:hover {
    background: #449d48;
}

/* Slide-in */
@keyframes drawerSlideIn {
    from {
        transform: translateX(100%);
    }
    to {
        transform: translateX(0);
    }
}

/* Slide-out */
@keyframes drawerSlideOut {
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(100%);
    }
}

.drawer {
    animation: drawerSlideIn 0.25s ease-out forwards;
}

.drawer.closing {
    animation: drawerSlideOut 0.25s ease-in forwards;
}

/* Fade-in */
@keyframes overlayFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

/* Fade-out */
@keyframes overlayFadeOut {
    from { opacity: 1; }
    to { opacity: 0; }
}

.drawer-overlay {
    animation: overlayFadeIn 0.25s ease-out forwards;
}

.drawer-overlay.closing {
    animation: overlayFadeOut 0.25s ease-in forwards;
}

/*///////////////////// NEW ////////////////////////*/

.toast-success {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #4caf50;
    color: white;
    /*padding: 12px 18px;*/
    border-radius: 8px;
    font-weight: 600;
    animation: toastFade 0.4s ease-out;
    /*z-index: 300;*/
}

.toast-success,
.toast-error {
    padding: 14px 18px 18px; /* un peu plus bas pour la barre */
    /*animation: fadeSlideIn 0.3s ease;*/
    z-index: 9999;
    overflow: hidden;
}

.toast-progress {
    height: 4px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 2px;
    margin-top: 8px;
    transition: width 0.03s linear;
}


.toast-warning {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #ef6c00;
    color: white;
    padding: 12px 18px;
    border-radius: 8px;
    font-weight: 600;
    animation: toastFade 0.4s ease-out;
    z-index: 300;
}

@keyframes toastFade {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.toast-error {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #d32f2f;
    color: white;
    /*padding: 12px 18px;*/
    border-radius: 8px;
    font-weight: 600;
    animation: toastFade 0.4s ease-out;
    /*z-index: 300;*/
    box-shadow: 0 4px 12px rgba(0,0,0,0.25);
}

.dark .toast-error {
    background: #b71c1c;
}

@keyframes toastFade {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Overlay plein écran */
.confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.45);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;   /* centre verticalement */
    justify-content: center; /* centre horizontalement */
    z-index: 300;
    animation: fadeIn 0.25s ease-out forwards;
}

/* Boîte centrée */
.confirm-box {
    background: var(--card-bg);
    color: var(--text-color);
    padding: 25px 30px;
    border-radius: 12px;
    width: 380px;
    box-shadow: 0 8px 25px rgba(0,0,0,0.25);
    text-align: center;
    animation: popupIn 0.25s ease-out forwards;
}

@keyframes popupIn {
    from {
        opacity: 0;
        transform: scale(0.92);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}
/* Animation overlay */
@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to
    {
        opacity: 1;
    }
}

.confirm-box.closing {
    animation: popupOut 0.2s ease-in forwards;
}

@keyframes popupOut {
    from {
        opacity: 1;
        transform: scale(1);
    }
    to {
        opacity: 0;
        transform: scale(0.92);
    }
}

/* Titre */
.confirm-box h3 {
    margin: 0 0 10px 0;
    font-size: 1.4rem;
    font-weight: 600;
}

/* Texte */
.confirm-box p {
    margin: 0 0 20px 0;
    font-size: 1rem;
    opacity: 0.85;
}

/* Boutons */
.confirm-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
}

.cancel-btn {
    padding: 10px 18px;
    background: #bdbdbd;
    color: #222;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-weight: 600;
    transition: 0.2s;
}

.cancel-btn:hover {
    background: #a4a4a4;
}

.delete-btn2 {
    padding: 10px 18px;
    background: #d32f2f;
    color: white;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-weight: 600;
    transition: 0.2s;
}

.delete-btn2:hover {
    background: #b71c1c;
}

/* Dark mode */
.dark .confirm-box {
    background: #1e1e1e;
    color: #fff;
}

.dark .cancel-btn {
    background: #555;
    color: #fff;
}

.dark .cancel-btn:hover {
    background: #666;
}



/*.session-timer {*/
/*    margin-left: 15px;*/
/*    padding: 6px 12px;*/
/*    background: rgba(255,255,255,0.1);*/
/*    border-radius: 8px;*/
/*    font-weight: 600;*/
/*    font-size: 0.9rem;*/
/*}*/

/*.dark .session-timer {*/
/*    background: rgba(0,0,0,0.3);*/
/*    color: #fff;*/
/*}*/

.session-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
}

/* Timer */
.session-timer {
    width: 180px;
    text-align: center;
    padding: 6px 12px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 0.9rem;
    color: white;
}

/* Couleurs dynamiques */
.session-timer.green {
    background: #2e7d32;
}

.session-timer.orange {
    background: #ef6c00;
}

.session-timer.red {
    background: #c62828;
}

/* Barre de progression */
.session-progress {
    width: 180px;
    height: 6px;
    background: rgba(255,255,255,0.2);
    border-radius: 4px;
    overflow: hidden;
}

.session-progress-bar {
    height: 100%;
    transition: width 0.5s linear;
}

/* Dark mode */
.dark .session-progress {
    background: rgba(0,0,0,0.3);
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    margin-top: 20px;
    flex-wrap: wrap;
}

.pagination button {
    padding: 8px 14px;
    border-radius: 6px;
    border: none;
    background: var(--card-bg);
    color: var(--text-color);
    cursor: pointer;
    transition: 0.2s;
    min-width: 40px;
}

.pagination button:hover:not(:disabled) {
    background: var(--primary-color);
    color: white;
}

.pagination button.active {
    background: var(--primary-color);
    color: white;
    font-weight: 700;
}

.pagination button:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.pagination .dots {
    padding: 8px 10px;
    opacity: 0.5;
    -webkit-user-select: none;
            user-select: none;
}

.users-table tbody {
    display: block;
    /*min-height: calc(10 * 48px); !* 10 lignes × hauteur d’une ligne *!*/
}

.users-table tr {
    height: 48px; /* hauteur fixe d’une ligne */
    display: table;
    width: 100%;
    table-layout: fixed;
}

.users-table thead {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.empty-row td {
    height: 48px; /* même hauteur que les lignes normales */
    background: transparent;
    border: none;
    pointer-events: none;
}

.users-search {
    display: flex;
    justify-content: flex-end;
}

.users-search input {
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid var(--border-color);
    background: var(--card-bg);
    color: var(--text-color);
    width: 260px;
    transition: 0.2s;
}

.users-search input:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}

.users-header-logo {
    display: flex;
    flex-direction: row;
    gap: 30px;
    align-items: center;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/Users.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,UAAU;AACV;IACI,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,uDAAuD;AAC3D;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;AACtC;;AAEA,qEAAqE;AACrE;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;;;AAIA;IACI,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,0BAA0B;IAC1B,aAAa;IACb,yBAAyB;IACzB,YAAY;AAChB;;AAEA,WAAW;AACX;IACI,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA,WAAW;AACX;;IAEI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,aAAa;AACb;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA,cAAc;AACd;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA,YAAY;AACZ;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA,aAAa;AACb;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA,qDAAqD;;AAErD;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB,EAAE,kCAAkC;IAC3D,oCAAoC;IACpC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,8BAA8B;AAClC;;;AAGA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB,IAAI,yBAAyB;IAChD,uBAAuB,EAAE,2BAA2B;IACpD,YAAY;IACZ,yCAAyC;AAC7C;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI;QACI,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;AACA,sBAAsB;AACtB;IACI;QACI,UAAU;IACd;IACA;;QAEI,UAAU;IACd;AACJ;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,sBAAsB;IAC1B;AACJ;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA,mBAAmB;AACnB,yBAAyB;AACzB,yBAAyB;AACzB,yCAAyC;AACzC,0BAA0B;AAC1B,wBAAwB;AACxB,yBAAyB;AACzB,IAAI;;AAEJ,yBAAyB;AACzB,mCAAmC;AACnC,mBAAmB;AACnB,IAAI;;AAEJ;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA,UAAU;AACV;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA,wBAAwB;AACxB;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,YAAY;IACZ,WAAW;IACX,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA,cAAc;AACd;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qEAAqE;AACzE;;AAEA;IACI,YAAY,EAAE,6BAA6B;IAC3C,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY,EAAE,yCAAyC;IACvD,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".users-page {\r\n    padding: 20px;\r\n}\r\n\r\n.users-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.users-header h1 {\r\n    font-size: 1.6rem;\r\n}\r\n\r\n.add-user-btn {\r\n    background: #4caf50;\r\n    color: white;\r\n    padding: 8px 14px;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n}\r\n\r\n.add-user-btn:hover {\r\n    background: #449d48;\r\n}\r\n\r\n/* Table */\r\n.users-table-wrapper {\r\n    background: var(--card-bg);\r\n    padding: 20px;\r\n    border-radius: 12px;\r\n    border: 1px solid #cfd6dd;\r\n}\r\n\r\n.dark .users-table-wrapper {\r\n    border-color: #2a333a;\r\n}\r\n\r\n.users-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.users-table th {\r\n    text-align: left;\r\n    padding-bottom: 12px;\r\n    font-size: 0.9rem;\r\n    opacity: 0.7;\r\n}\r\n\r\n.users-table td {\r\n    padding: 12px 0;\r\n    border-bottom: 1px solid rgba(0,0,0,0.06);\r\n}\r\n\r\n.dark .users-table td {\r\n    border-bottom-color: rgba(255,255,255,0.06);\r\n}\r\n\r\n/* Badges rôle */\r\n.role-badge {\r\n    padding: 4px 10px;\r\n    border-radius: 6px;\r\n    font-size: 0.8rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.role-badge.admin {\r\n    background: rgba(211, 47, 47, 0.15);\r\n    color: #d32f2f;\r\n}\r\n\r\n.role-badge.moderateur {\r\n    background: rgba(249, 168, 37, 0.15);\r\n    color: #f9a825;\r\n}\r\n\r\n.role-badge.utilisateur {\r\n    background: rgba(25, 118, 210, 0.15);\r\n    color: #1976d2;\r\n}\r\n\r\n/* Badges statut */\r\n.status-badge {\r\n    padding: 4px 10px;\r\n    border-radius: 6px;\r\n    font-size: 0.8rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.status-badge.actif {\r\n    background: rgba(76, 175, 80, 0.15);\r\n    color: #4caf50;\r\n}\r\n\r\n.status-badge.suspendu {\r\n    background: rgba(211, 47, 47, 0.15);\r\n    color: #d32f2f;\r\n}\r\n\r\n/* Actions */\r\n.actions button {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 1.1rem;\r\n    margin-right: 8px;\r\n}\r\n\r\n.actions button:hover {\r\n    opacity: 0.7;\r\n}\r\n\r\n.seeyou {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.seeyou button:hover {\r\n    opacity: 0.7;\r\n}\r\n\r\n.seeyou button {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 1.1rem;\r\n    /*margin-right: 8px;*/\r\n}\r\n\r\n/* Message button */\r\n.message-btn {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 1rem;\r\n    margin-right: 8px;\r\n    padding: 6px 8px;\r\n    border-radius: 6px;\r\n    transition: background 120ms ease, transform 120ms ease;\r\n}\r\n\r\n.message-btn:hover {\r\n    background: rgba(0,0,0,0.04);\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.dark .message-btn:hover {\r\n    background: rgba(255,255,255,0.03);\r\n}\r\n\r\n/* Drawer action buttons: make Send/Cancel same size inside drawers */\r\n.drawer .drawer-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-top: 8px;\r\n}\r\n\r\n\r\n\r\n.drawer .drawer-actions .save-user-btn {\r\n    font-weight: 700;\r\n}\r\n\r\n/* Overlay */\r\n.drawer-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0,0,0,0.35);\r\n    backdrop-filter: blur(2px);\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    z-index: 200;\r\n}\r\n\r\n/* Drawer */\r\n.drawer {\r\n    width: 340px;\r\n    background: var(--card-bg);\r\n    height: 100%;\r\n    padding: 24px;\r\n    border-left: 1px solid #cfd6dd;\r\n    animation: drawerSlide 0.25s ease-out;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n}\r\n\r\n.dark .drawer {\r\n    border-color: #2a333a;\r\n}\r\n\r\n@keyframes drawerSlide {\r\n    from {\r\n        transform: translateX(100%);\r\n    }\r\n    to {\r\n        transform: translateX(0);\r\n    }\r\n}\r\n\r\n/* Inputs */\r\n.drawer input,\r\n.drawer select {\r\n    padding: 8px;\r\n    border-radius: 6px;\r\n    border: 1px solid #cfd6dd;\r\n    background: var(--bg);\r\n    color: var(--text);\r\n}\r\n\r\n.dark .drawer input,\r\n.dark .drawer select {\r\n    border-color: #2a333a;\r\n}\r\n\r\n/* Save button */\r\n.save-user-btn {\r\n    margin-top: 10px;\r\n    background: #4caf50;\r\n    color: white;\r\n    padding: 10px;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n}\r\n\r\n.save-user-btn:hover {\r\n    background: #449d48;\r\n}\r\n\r\n/* Slide-in */\r\n@keyframes drawerSlideIn {\r\n    from {\r\n        transform: translateX(100%);\r\n    }\r\n    to {\r\n        transform: translateX(0);\r\n    }\r\n}\r\n\r\n/* Slide-out */\r\n@keyframes drawerSlideOut {\r\n    from {\r\n        transform: translateX(0);\r\n    }\r\n    to {\r\n        transform: translateX(100%);\r\n    }\r\n}\r\n\r\n.drawer {\r\n    animation: drawerSlideIn 0.25s ease-out forwards;\r\n}\r\n\r\n.drawer.closing {\r\n    animation: drawerSlideOut 0.25s ease-in forwards;\r\n}\r\n\r\n/* Fade-in */\r\n@keyframes overlayFadeIn {\r\n    from { opacity: 0; }\r\n    to { opacity: 1; }\r\n}\r\n\r\n/* Fade-out */\r\n@keyframes overlayFadeOut {\r\n    from { opacity: 1; }\r\n    to { opacity: 0; }\r\n}\r\n\r\n.drawer-overlay {\r\n    animation: overlayFadeIn 0.25s ease-out forwards;\r\n}\r\n\r\n.drawer-overlay.closing {\r\n    animation: overlayFadeOut 0.25s ease-in forwards;\r\n}\r\n\r\n/*///////////////////// NEW ////////////////////////*/\r\n\r\n.toast-success {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    right: 20px;\r\n    background: #4caf50;\r\n    color: white;\r\n    /*padding: 12px 18px;*/\r\n    border-radius: 8px;\r\n    font-weight: 600;\r\n    animation: toastFade 0.4s ease-out;\r\n    /*z-index: 300;*/\r\n}\r\n\r\n.toast-success,\r\n.toast-error {\r\n    padding: 14px 18px 18px; /* un peu plus bas pour la barre */\r\n    /*animation: fadeSlideIn 0.3s ease;*/\r\n    z-index: 9999;\r\n    overflow: hidden;\r\n}\r\n\r\n.toast-progress {\r\n    height: 4px;\r\n    background: rgba(255, 255, 255, 0.8);\r\n    border-radius: 2px;\r\n    margin-top: 8px;\r\n    transition: width 0.03s linear;\r\n}\r\n\r\n\r\n.toast-warning {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    right: 20px;\r\n    background: #ef6c00;\r\n    color: white;\r\n    padding: 12px 18px;\r\n    border-radius: 8px;\r\n    font-weight: 600;\r\n    animation: toastFade 0.4s ease-out;\r\n    z-index: 300;\r\n}\r\n\r\n@keyframes toastFade {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(10px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.toast-error {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    right: 20px;\r\n    background: #d32f2f;\r\n    color: white;\r\n    /*padding: 12px 18px;*/\r\n    border-radius: 8px;\r\n    font-weight: 600;\r\n    animation: toastFade 0.4s ease-out;\r\n    /*z-index: 300;*/\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.25);\r\n}\r\n\r\n.dark .toast-error {\r\n    background: #b71c1c;\r\n}\r\n\r\n@keyframes toastFade {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(10px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n/* Overlay plein écran */\r\n.confirm-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0,0,0,0.45);\r\n    backdrop-filter: blur(4px);\r\n    display: flex;\r\n    align-items: center;   /* centre verticalement */\r\n    justify-content: center; /* centre horizontalement */\r\n    z-index: 300;\r\n    animation: fadeIn 0.25s ease-out forwards;\r\n}\r\n\r\n/* Boîte centrée */\r\n.confirm-box {\r\n    background: var(--card-bg);\r\n    color: var(--text-color);\r\n    padding: 25px 30px;\r\n    border-radius: 12px;\r\n    width: 380px;\r\n    box-shadow: 0 8px 25px rgba(0,0,0,0.25);\r\n    text-align: center;\r\n    animation: popupIn 0.25s ease-out forwards;\r\n}\r\n\r\n@keyframes popupIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: scale(0.92);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}\r\n/* Animation overlay */\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n    }\r\n    to\r\n    {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.confirm-box.closing {\r\n    animation: popupOut 0.2s ease-in forwards;\r\n}\r\n\r\n@keyframes popupOut {\r\n    from {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n    to {\r\n        opacity: 0;\r\n        transform: scale(0.92);\r\n    }\r\n}\r\n\r\n/* Titre */\r\n.confirm-box h3 {\r\n    margin: 0 0 10px 0;\r\n    font-size: 1.4rem;\r\n    font-weight: 600;\r\n}\r\n\r\n/* Texte */\r\n.confirm-box p {\r\n    margin: 0 0 20px 0;\r\n    font-size: 1rem;\r\n    opacity: 0.85;\r\n}\r\n\r\n/* Boutons */\r\n.confirm-actions {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 15px;\r\n}\r\n\r\n.cancel-btn {\r\n    padding: 10px 18px;\r\n    background: #bdbdbd;\r\n    color: #222;\r\n    border-radius: 8px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    transition: 0.2s;\r\n}\r\n\r\n.cancel-btn:hover {\r\n    background: #a4a4a4;\r\n}\r\n\r\n.delete-btn2 {\r\n    padding: 10px 18px;\r\n    background: #d32f2f;\r\n    color: white;\r\n    border-radius: 8px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    transition: 0.2s;\r\n}\r\n\r\n.delete-btn2:hover {\r\n    background: #b71c1c;\r\n}\r\n\r\n/* Dark mode */\r\n.dark .confirm-box {\r\n    background: #1e1e1e;\r\n    color: #fff;\r\n}\r\n\r\n.dark .cancel-btn {\r\n    background: #555;\r\n    color: #fff;\r\n}\r\n\r\n.dark .cancel-btn:hover {\r\n    background: #666;\r\n}\r\n\r\n\r\n\r\n/*.session-timer {*/\r\n/*    margin-left: 15px;*/\r\n/*    padding: 6px 12px;*/\r\n/*    background: rgba(255,255,255,0.1);*/\r\n/*    border-radius: 8px;*/\r\n/*    font-weight: 600;*/\r\n/*    font-size: 0.9rem;*/\r\n/*}*/\r\n\r\n/*.dark .session-timer {*/\r\n/*    background: rgba(0,0,0,0.3);*/\r\n/*    color: #fff;*/\r\n/*}*/\r\n\r\n.session-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-end;\r\n    gap: 6px;\r\n}\r\n\r\n/* Timer */\r\n.session-timer {\r\n    width: 180px;\r\n    text-align: center;\r\n    padding: 6px 12px;\r\n    border-radius: 8px;\r\n    font-weight: 600;\r\n    font-size: 0.9rem;\r\n    color: white;\r\n}\r\n\r\n/* Couleurs dynamiques */\r\n.session-timer.green {\r\n    background: #2e7d32;\r\n}\r\n\r\n.session-timer.orange {\r\n    background: #ef6c00;\r\n}\r\n\r\n.session-timer.red {\r\n    background: #c62828;\r\n}\r\n\r\n/* Barre de progression */\r\n.session-progress {\r\n    width: 180px;\r\n    height: 6px;\r\n    background: rgba(255,255,255,0.2);\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n}\r\n\r\n.session-progress-bar {\r\n    height: 100%;\r\n    transition: width 0.5s linear;\r\n}\r\n\r\n/* Dark mode */\r\n.dark .session-progress {\r\n    background: rgba(0,0,0,0.3);\r\n}\r\n\r\n.pagination {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 6px;\r\n    margin-top: 20px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.pagination button {\r\n    padding: 8px 14px;\r\n    border-radius: 6px;\r\n    border: none;\r\n    background: var(--card-bg);\r\n    color: var(--text-color);\r\n    cursor: pointer;\r\n    transition: 0.2s;\r\n    min-width: 40px;\r\n}\r\n\r\n.pagination button:hover:not(:disabled) {\r\n    background: var(--primary-color);\r\n    color: white;\r\n}\r\n\r\n.pagination button.active {\r\n    background: var(--primary-color);\r\n    color: white;\r\n    font-weight: 700;\r\n}\r\n\r\n.pagination button:disabled {\r\n    opacity: 0.4;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.pagination .dots {\r\n    padding: 8px 10px;\r\n    opacity: 0.5;\r\n    user-select: none;\r\n}\r\n\r\n.users-table tbody {\r\n    display: block;\r\n    /*min-height: calc(10 * 48px); !* 10 lignes × hauteur d’une ligne *!*/\r\n}\r\n\r\n.users-table tr {\r\n    height: 48px; /* hauteur fixe d’une ligne */\r\n    display: table;\r\n    width: 100%;\r\n    table-layout: fixed;\r\n}\r\n\r\n.users-table thead {\r\n    display: table;\r\n    width: 100%;\r\n    table-layout: fixed;\r\n}\r\n\r\n.empty-row td {\r\n    height: 48px; /* même hauteur que les lignes normales */\r\n    background: transparent;\r\n    border: none;\r\n    pointer-events: none;\r\n}\r\n\r\n.users-search {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.users-search input {\r\n    padding: 10px 14px;\r\n    border-radius: 8px;\r\n    border: 1px solid var(--border-color);\r\n    background: var(--card-bg);\r\n    color: var(--text-color);\r\n    width: 260px;\r\n    transition: 0.2s;\r\n}\r\n\r\n.users-search input:focus {\r\n    outline: none;\r\n    border-color: var(--primary-color);\r\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);\r\n}\r\n\r\n.users-header-logo {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 30px;\r\n    align-items: center;\r\n    justify-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
